/**    
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  'use strict';

  var QuantityToVariantMatcher = {
    isProcessing: false,
    
    init: function() {
      this.attachQuantityListener();
    },

    attachQuantityListener: function() {
      var self = this;
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(function() {
            self.setupListeners();
          }, 100);
        });
      } else {
        setTimeout(function() {
          self.setupListeners();
        }, 100);
      }
    },

    setupListeners: function() {
      var self = this;
      var quantitySelector = document.querySelector('.quantity-selector--product');
      
      if (!quantitySelector) return;

      var quantityInput = quantitySelector.querySelector('.quantity-selector__value');
      var increaseButton = quantitySelector.querySelector('[data-action="increase-picker-quantity"]');
      var decreaseButton = quantitySelector.querySelector('[data-action="decrease-picker-quantity"]');
      
      if (!quantityInput) return;

      quantityInput.addEventListener('change', function(e) {
        if (!self.isProcessing) {
          self.handleQuantityChange(parseInt(e.target.value) || 1);
        }
      });

      quantityInput.addEventListener('input', function(e) {
        if (self.isProcessing) return;
        
        var quantity = parseInt(e.target.value) || 1;
        clearTimeout(self.inputTimeout);
        self.inputTimeout = setTimeout(function() {
          self.handleQuantityChange(quantity);
        }, 500);
      });

      if (increaseButton) {
        increaseButton.addEventListener('click', function() {
          setTimeout(function() {
            if (!self.isProcessing) {
              var newQuantity = parseInt(quantityInput.value) || 1;
              self.handleQuantityChange(newQuantity);
            }
          }, 50);
        });
      }

      if (decreaseButton) {
        decreaseButton.addEventListener('click', function() {
          setTimeout(function() {
            if (!self.isProcessing) {
              var newQuantity = parseInt(quantityInput.value) || 1;
              self.handleQuantityChange(newQuantity);
            }
          }, 50);
        });
      }
    },

    handleQuantityChange: function(selectedQuantity) {
      if (this.isProcessing) return;
      
      try {
        this.isProcessing = true;

        var productForm = document.querySelector('.product-form');
        if (!productForm) {
          this.isProcessing = false;
          return;
        }

        var variantData = this.getProductVariants(productForm);
        if (!variantData || !variantData.variants || variantData.variants.length === 0) {
          this.isProcessing = false;
          return;
        }

        var bestMatch = this.findBestMatchingVariant(variantData.variants, selectedQuantity);
        
        if (bestMatch && bestMatch.optionValue) {
          this.selectVariant(variantData.firstOptionSelectors, bestMatch.optionValue);
        }

        var self = this;
        setTimeout(function() {
          self.isProcessing = false;
        }, 300);
        
      } catch (error) {
        console.error('QuantityToVariantMatcher error:', error);
        this.isProcessing = false;
      }
    },

    getProductVariants: function(productForm) {
      try {
        var productSection = productForm.closest('[data-section-type="product"]');
        if (!productSection) return null;

        var productDataScript = productSection.querySelector('[data-product-json]');
        if (!productDataScript || !productDataScript.textContent) return null;

        var productData = JSON.parse(productDataScript.textContent);
        if (!productData || !productData.product || !productData.product.variants) return null;

        var variants = productData.product.variants;
        var firstOptionSelectors = productForm.querySelectorAll(
          '.product-form__single-selector[data-option-position="1"]'
        );

        if (!firstOptionSelectors || firstOptionSelectors.length === 0) return null;

        return {
          variants: variants,
          firstOptionSelectors: firstOptionSelectors
        };
      } catch (e) {
        console.error('Error parsing product data:', e);
        return null;
      }
    },

    findBestMatchingVariant: function(variants, targetQuantity) {
      if (!variants || variants.length === 0) return null;
      if (isNaN(targetQuantity) || targetQuantity < 1) return null;

      var variantQuantities = [];

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (!variant || !variant.option1) continue;

        var optionValue = variant.option1;
        var numbers = optionValue.match(/\d+/g);
        
        if (numbers && numbers.length > 0) {
          var quantity = parseInt(numbers[0]);
          if (!isNaN(quantity) && quantity > 0) {
            variantQuantities.push({
              quantity: quantity,
              optionValue: optionValue,
              variant: variant
            });
          }
        }
      }

      if (variantQuantities.length === 0) return null;

      variantQuantities.sort(function(a, b) {
        return a.quantity - b.quantity;
      });

      var bestMatch = null;
      
      for (var j = 0; j < variantQuantities.length; j++) {
        if (variantQuantities[j].quantity === targetQuantity) {
          bestMatch = variantQuantities[j];
          break;
        }
        
        if (variantQuantities[j].quantity < targetQuantity) {
          bestMatch = variantQuantities[j];
        } else {
          break;
        }
      }

      if (!bestMatch && variantQuantities.length > 0) {
        bestMatch = variantQuantities[0];
      }

      return bestMatch;
    },

    selectVariant: function(selectors, optionValue) {
      if (!selectors || selectors.length === 0 || !optionValue) return;

      try {
        for (var i = 0; i < selectors.length; i++) {
          var selector = selectors[i];
          if (!selector) continue;

          if (selector.type === 'radio') {
            if (selector.value === optionValue && !selector.checked) {
              selector.checked = true;
              
              var changeEvent = document.createEvent('HTMLEvents');
              changeEvent.initEvent('change', true, true);
              selector.dispatchEvent(changeEvent);
              break;
            }
          } else if (selector.tagName === 'SELECT') {
            if (selector.value !== optionValue) {
              selector.value = optionValue;
              
              var selectChangeEvent = document.createEvent('HTMLEvents');
              selectChangeEvent.initEvent('change', true, true);
              selector.dispatchEvent(selectChangeEvent);
              break;
            }
          }
        }
      } catch (error) {
        console.error('Error selecting variant:', error);
      }
    }
  };

  var ProductPageDiscountPricing = {
    processingRequest: false,
    updateTimeout: null,
    lastRequestId: 0,
    discountDetected: false,

    init: function() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.setup.bind(this));
      } else {
        this.setup();
      }
    },

    setup: function() {
      var self = this;
      var quantitySelector = document.querySelector('.quantity-selector--product');
      
      if (!quantitySelector) return;

      var quantityInput = quantitySelector.querySelector('.quantity-selector__value');
      var increaseButton = quantitySelector.querySelector('[data-action="increase-picker-quantity"]');
      var decreaseButton = quantitySelector.querySelector('[data-action="decrease-picker-quantity"]');
      
      if (!quantityInput) return;

      quantityInput.addEventListener('change', function() {
        self.scheduleUpdate(false);
      });

      quantityInput.addEventListener('input', function() {
        self.scheduleUpdate(true);
      });

      if (increaseButton) {
        increaseButton.addEventListener('click', function() {
          setTimeout(function() {
            self.scheduleUpdate(false);
          }, 50);
        });
      }

      if (decreaseButton) {
        decreaseButton.addEventListener('click', function() {
          setTimeout(function() {
            self.scheduleUpdate(false);
          }, 50);
        });
      }

      document.addEventListener('variant:changed', function() {
        self.discountDetected = false;
      });
    },

    scheduleUpdate: function(isTyping) {
      clearTimeout(this.updateTimeout);
      var self = this;
      var delay = isTyping ? 400 : 150;
      this.updateTimeout = setTimeout(function() {
        self.updatePriceWithDiscount();
      }, delay);
    },

    getCurrentVariantId: function() {
      var productForm = document.querySelector('.product-form');
      if (!productForm) return null;

      var variantIdInput = productForm.querySelector('input[name="id"]');
      if (variantIdInput) {
        return variantIdInput.value;
      }

      var productSection = productForm.closest('[data-section-type="product"]');
      if (!productSection) return null;

      var productDataScript = productSection.querySelector('[data-product-json]');
      if (!productDataScript) return null;

      try {
        var productData = JSON.parse(productDataScript.textContent);
        return productData.selected_variant_id;
      } catch (e) {
        return null;
      }
    },

    getQuantity: function() {
      var quantityInput = document.querySelector('.quantity-selector--product .quantity-selector__value');
      return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    },

    updatePriceWithDiscount: function() {
      if (this.processingRequest) return;
      
      var self = this;
      var variantId = this.getCurrentVariantId();
      var quantity = this.getQuantity();
      var requestId = ++this.lastRequestId;

      if (!variantId || !quantity) return;

      this.processingRequest = true;
      this.showLoadingState();

      fetch(window.routes.cartUrl + '.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        if (requestId !== self.lastRequestId) {
          self.processingRequest = false;
          return Promise.reject('Cancelled');
        }

        var existingLineItem = null;
        var existingQuantity = 0;
        
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id == variantId) {
            existingLineItem = cart.items[i];
            existingQuantity = cart.items[i].quantity;
            break;
          }
        }
        
        if (existingLineItem) {
          return fetch(window.routes.cartChangeUrl + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(updatedCart) {
            return new Promise(function(resolve) {
              setTimeout(function() {
                resolve(updatedCart);
              }, 1000);
            });
          })
          .then(function(updatedCart) {
            return fetch(window.routes.cartUrl + '.js?t=' + Date.now(), {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Cache-Control': 'no-cache'
              }
            });
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(finalCart) {
            return {
              cart: finalCart,
              needsRestore: true,
              originalQuantity: existingQuantity
            };
          });
        } else {
          return fetch(window.routes.cartUrl + '/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          })
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Failed to add to cart');
            }
            return response.json();
          })
          .then(function(addedItem) {
            return new Promise(function(resolve) {
              setTimeout(function() {
                resolve();
              }, 1000);
            }).then(function() {
              return fetch(window.routes.cartUrl + '.js?t=' + Date.now(), {
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Cache-Control': 'no-cache'
                }
              });
            });
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(updatedCart) {
            return {
              cart: updatedCart,
              needsRestore: false,
              originalQuantity: 0
            };
          });
        }
      })
      .then(function(result) {
        if (requestId !== self.lastRequestId) {
          self.processingRequest = false;
          return Promise.reject('Cancelled');
        }

        var lineItem = null;
        for (var i = 0; i < result.cart.items.length; i++) {
          if (result.cart.items[i].variant_id == variantId) {
            lineItem = result.cart.items[i];
            break;
          }
        }

        if (lineItem) {
          console.log('Updating price display:', {
            quantity: quantity,
            final_line_price: lineItem.final_line_price,
            original_line_price: lineItem.original_line_price,
            final_price: lineItem.final_price,
            original_price: lineItem.original_price,
            variant_price: lineItem.variant ? lineItem.variant.price : 'N/A',
            hasDiscount: lineItem.final_line_price < lineItem.original_line_price,
            discountAmount: lineItem.original_line_price - lineItem.final_line_price
          });
          
          var hasDiscount = lineItem.final_line_price < lineItem.original_line_price && quantity >= 3;
          
          if (hasDiscount) {
            self.discountDetected = true;
            self.displayDiscountedPrice(lineItem, quantity, true);
            console.log('✅ Discount detected for quantity ' + quantity + ' - updating price display');
          } else {
            self.discountDetected = false;
            self.displayDiscountedPrice(lineItem, quantity, false);
            console.log('⚠️ Quantity ' + quantity + ' - no discount, showing regular price');
          }
        }

        var restoreQuantity = result.needsRestore ? result.originalQuantity : 0;
        
        return fetch(window.routes.cartChangeUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: restoreQuantity
          })
        });
      })
      .then(function() {
        if (requestId !== self.lastRequestId) {
          return;
        }
        self.processingRequest = false;
        self.hideLoadingState();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function(error) {
        if (error !== 'Cancelled') {
          console.error('Error fetching discount price:', error);
        }
        self.processingRequest = false;
        self.hideLoadingState();
      });
    },

    showLoadingState: function() {
    },

    hideLoadingState: function() {
    },

    displayDiscountedPrice: function(lineItem, quantity, shouldShowDiscount) {
      var priceList = document.querySelector('.product-form__info-content .price-list');
      if (!priceList) {
        console.log('Price list element not found');
        return;
      }

      console.log('Displaying price for quantity:', quantity, 'Show discount:', shouldShowDiscount);
      
      if (shouldShowDiscount && lineItem.final_line_price < lineItem.original_line_price) {
        var totalPrice = lineItem.final_line_price;
        var originalTotalPrice = lineItem.original_line_price;
        
        console.log('Showing automatic discount - Total:', totalPrice, 'Original:', originalTotalPrice);
        
        priceList.innerHTML = 
          '<span class="price price--highlight">' +
          '<span class="visually-hidden">Sale price</span>' +
          this.formatMoney(totalPrice) +
          '</span>' +
          '<span class="price price--compare">' +
          '<span class="visually-hidden">Regular price</span>' +
          this.formatMoney(originalTotalPrice) +
          '</span>';

        var productLabelList = document.querySelector('.product-meta__label-list');
        if (productLabelList) {
          var discountLabel = productLabelList.querySelector('.product-label--on-sale');
          if (discountLabel) {
            var savings = originalTotalPrice - totalPrice;
            var savingsPercent = Math.round((savings / originalTotalPrice) * 100);
            discountLabel.textContent = '-' + savingsPercent + '%';
            discountLabel.style.display = '';
          }
        }
      } else {
        var unitPrice = lineItem.variant ? lineItem.variant.price : lineItem.original_price;
        var totalPrice = unitPrice * quantity;
        
        console.log('Showing regular price - Unit:', unitPrice, 'Total:', totalPrice);
        
        if (lineItem.variant && lineItem.variant.compare_at_price > lineItem.variant.price) {
          var compareTotalPrice = lineItem.variant.compare_at_price * quantity;
          console.log('Has compare_at_price - showing that as well');
          
          priceList.innerHTML = 
            '<span class="price price--highlight">' +
            '<span class="visually-hidden">Sale price</span>' +
            this.formatMoney(totalPrice) +
            '</span>' +
            '<span class="price price--compare">' +
            '<span class="visually-hidden">Regular price</span>' +
            this.formatMoney(compareTotalPrice) +
            '</span>';
            
          var productLabelList = document.querySelector('.product-meta__label-list');
          if (productLabelList) {
            var discountLabel = productLabelList.querySelector('.product-label--on-sale');
            if (discountLabel) {
              var savings = compareTotalPrice - totalPrice;
              var savingsPercent = Math.round((savings / compareTotalPrice) * 100);
              discountLabel.textContent = '-' + savingsPercent + '%';
              discountLabel.style.display = '';
            }
          }
        } else {
          console.log('No discount - showing normal price');
          
          priceList.innerHTML = 
            '<span class="price">' +
            '<span class="visually-hidden">Sale price</span>' +
            this.formatMoney(totalPrice) +
            '</span>';
            
          var productLabelList = document.querySelector('.product-meta__label-list');
          if (productLabelList) {
            var discountLabel = productLabelList.querySelector('.product-label--on-sale');
            if (discountLabel) {
              discountLabel.style.display = 'none';
            }
          }
        }
      }
    },

    formatMoney: function(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  };

  var QuantityImageSelector = {
    init: function() {
      var quantitySelector = document.querySelector('[data-quantity-selector]');
      if (!quantitySelector) {
        console.log('Quantity Image Selector block not found - skipping initialization');
        return;
      }

      console.log('Quantity Image Selector block found - initializing');
      this.attachImageClickListeners();
      this.attachQuantityChangeListener();
    },

    attachImageClickListeners: function() {
      var self = this;
      var quantitySelector = document.querySelector('[data-quantity-selector]');
      
      if (!quantitySelector) return;

      var imageItems = quantitySelector.querySelectorAll('.quantity-image-selector__item');
      
      imageItems.forEach(function(item) {
        item.addEventListener('click', function() {
          self.handleImageClick(this, imageItems);
        });
      });

      if (imageItems.length > 0) {
        imageItems[0].classList.add('is-active');
      }
    },

    attachQuantityChangeListener: function() {
      var self = this;
      var quantitySelector = document.querySelector('[data-quantity-selector]');
      if (!quantitySelector) return;

      var quantityInput = document.querySelector('.product-form__quantity input[name="quantity"]');
      if (!quantityInput) {
        quantityInput = document.querySelector('input[name="quantity"]');
      }

      if (quantityInput) {
        console.log('Attaching quantity change listeners');
        
        quantityInput.addEventListener('change', function() {
          console.log('Quantity changed to:', this.value);
          self.updateImageSelection(parseInt(this.value));
        });

        quantityInput.addEventListener('input', function() {
          console.log('Quantity input changed to:', this.value);
          self.updateImageSelection(parseInt(this.value));
        });

        var quantityButtons = document.querySelectorAll('[data-action="decrease-picker-quantity"], [data-action="increase-picker-quantity"]');
        console.log('Found quantity buttons:', quantityButtons.length);
        
        quantityButtons.forEach(function(button) {
          button.addEventListener('click', function() {
            console.log('Quantity button clicked');
            setTimeout(function() {
              var newQuantity = parseInt(quantityInput.value);
              console.log('Updating image selection for quantity:', newQuantity);
              self.updateImageSelection(newQuantity);
            }, 100);
          });
        });
      } else {
        console.log('Quantity input not found');
      }
    },

    updateImageSelection: function(quantity) {
      var quantitySelector = document.querySelector('[data-quantity-selector]');
      if (!quantitySelector) return;

      var imageItems = quantitySelector.querySelectorAll('.quantity-image-selector__item');
      if (imageItems.length === 0) return;

      var selectedIndex = 0;
      
      if (quantity >= 1 && quantity <= 2) {
        selectedIndex = 0;
      } else if (quantity >= 3 && quantity <= 4) {
        selectedIndex = 1;
      } else if (quantity >= 5) {
        selectedIndex = 2;
      }

      console.log('Updating image selection - Quantity:', quantity, 'Selected index:', selectedIndex);

      imageItems.forEach(function(item, index) {
        if (index === selectedIndex) {
          item.classList.add('is-active');
          console.log('Image', index + 1, 'activated');
        } else {
          item.classList.remove('is-active');
        }
      });
    },

    handleImageClick: function(clickedItem, allItems) {
      allItems.forEach(function(item) {
        item.classList.remove('is-active');
      });
      
      clickedItem.classList.add('is-active');
      
      var quantity = parseInt(clickedItem.getAttribute('data-quantity'));
      
      if (isNaN(quantity)) return;
      
      var quantityInput = document.querySelector('.product-form__quantity input[name="quantity"]');
      if (!quantityInput) {
        quantityInput = document.querySelector('input[name="quantity"]');
      }
      
      if (quantityInput) {
        quantityInput.value = quantity;
        
        var changeEvent = new Event('change', { bubbles: true });
        quantityInput.dispatchEvent(changeEvent);
        
        console.log('Quantity set to:', quantity);
      }
    }
  };

  QuantityToVariantMatcher.init();
  ProductPageDiscountPricing.init();
  QuantityImageSelector.init();
})();

